class Popup {
    constructor() {
        this.popup();
    }

    popup() {
        $('body').on('click', '.popup-video', (e) => {
            let elem = $(e.currentTarget);
            let dataType = elem.attr('data-type');
            let dataVideoId = elem.attr('data-video');
            let dataControls = elem.attr('data-controls');
            let videoSrc = '';
            if (dataType === 'youtube') {
                videoSrc = '//www.youtube.com/embed/' + dataVideoId + '?rel=0&autoplay=1&showinfo=0&controls=0&loop=1&mute=1&playlist=' + dataVideoId;
            } else if (dataType === 'vimeo') {
                if (dataControls === '1') {
                    videoSrc = '//player.vimeo.com/video/' + dataVideoId + '?autoplay=1&background=0&controls=1&loop=1&muted=0&byline=0&playsinline=1&title=0&autopause=1';
                } else {
                    videoSrc = '//player.vimeo.com/video/' + dataVideoId + '?autoplay=1&background=1&controls=1&loop=1&muted=1&byline=0&playsinline=1&title=0&autopause=1';
                }
            }

            if (videoSrc) {
                $('#watchreelModal').modal('show');
                $('#watchreelModal iframe.video-src').attr('src', videoSrc);
                $('#watchreelModal iframe').on('load', function () {
                    $(this).parents('.modal-body').addClass('loaded');
                });
            }
        })
        $('#watchreelModal').on('hidden.bs.modal',(e)=>{
            let elem = $(e.currentTarget);
            elem.find('.video-src').attr('src', '');
            elem.find('.modal-body').removeClass('loaded');
        })



    }
}

export default Popup;